<template>
  <div class="basics">
    <Header :present-page="presentPage" />
    <div class="container">
      <h5>设备配置</h5>
      <a-form
        class="a-form"
        @submit="handleSubmit"
      >
        <a-form-item label="默认线路">
          <a-select ref="select">
            <a-select-option value="jack">Jack</a-select-option>
            <a-select-option value="lucy">Lucy</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="默认桥梁">
          <a-select ref="select">
            <a-select-option value="jack">Jack</a-select-option>
            <a-select-option value="lucy">Lucy</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="默认产品">
          <a-select ref="select">
            <a-select-option value="jack">Jack</a-select-option>
            <a-select-option value="lucy">Lucy</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="默认设备">
          <a-select ref="select">
            <a-select-option value="jack">Jack</a-select-option>
            <a-select-option value="lucy">Lucy</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button class="cancel">取消</a-button>
          <a-button class="confirm">保存</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue';

export default {
  name: "SensorConfig",
  components: {
    Header,
    PlusOutlined,
    LoadingOutlined,
  },
  data() {
    return {
      presentPage: '',
      formState: {
        username: ''
      },
      loading: false,
      imageUrl: '',
    };
  },
  mounted() {
    this.presentPage = this.$route.query.name
  },
  methods: {
    handleSubmit(e) {
      console.log(e)
    },
  },
};
</script>
<style scoped>
.container {
  padding: 20px;
  margin: 20px 30px;
  background: #fff;
  border-radius: 15px;
}
h5 {
  width: 600px;
  padding-left: 10px;
  margin: 20px auto;
  text-align: left;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #222;
  border-left: 5px solid #0088ff;
}
.a-form {
  width: 600px;
  margin: 0 auto;
}
.a-form :deep() .ant-form-item-label > label {
  width: 100px;
  height: 40px;
}
.ant-select :deep() .ant-select-selector {
  width: 500px;
  height: 40px;
  text-align: left;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selection-item {
  height: 38px;
  line-height: 38px;
}
.a-form :deep() .cancel {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
  border-radius: 6px;
}
.a-form :deep() .confirm {
  width: 80px;
  height: 36px;
  color: #fff;
  border: 0;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.a-form :deep() .ant-form-item-control-input-content {
  text-align: right;
}
</style>